export enum ItemAction {
  Clone = 0,
  Delete = 1,
  Edit = 2,
  View = 3,
  Downgrade = 4,
  Add = 5
}
